import React from "react";
import Assessment from "components/Assessment";
import Error from "./Error";
import DeactivatedProfile from "./DeactivatedProfile";
import NotFound from "./NotFound";
import Registration from "./Registration";
import Login from "./Login";
import Welcome from "./Welcome";
import Onboarding from "./Onboarding";
import Home from "components/Home";
import Bookmark from "../components/Bookmark";
import Activation from "./Activation";
import ForgotPassword from "./ForgotPassword";
import MobileDeviceError from "./MobileDeviceError";
import PrivacyPolicy from "./PrivacyPolicy";
import PrivateRoute from "components/PrivateRoute";
import FeatureRoute from "components/FeatureRoute";
import SessionHelper from "components/SessionHelper";
import ResetPassword from "./ResetPassword";
import VerifyAccount from "./VerifyAccount";
import Performance from "./Performance";
import Workspace from "./Workspace";
import Profile from "components/Profile";
import BatchInvite from "./BatchInvite";
import Blog from "./Blog";
import theme from "theme";
import ProctoringProvider from "contexts/ProctoringProvider";
import ErrorBoundary from "../components/ErrorBoundary";
import Pathway from "components/Pathway";
import Auth, { AuthForAssessmentLink } from "./Auth";
import UnsupportedBrowser, { UnsupportedDevice } from "./UnsupportedBrowser";

import {
  BrowserRouter, Navigate, Route, Routes,
} from "react-router-dom";
import { useEffect } from "react";
import {
  SnackbarProvider,
  LoadingProvider,
  SingleSessionProvider,
  ConnectivityProvider,
  TourProvider
} from "contexts";
import { ThemeProvider } from '@mui/material/styles';
import { StackSnackbarProvider } from "contexts/StackSnackbarProvider";
import { initOpenReplay } from "utils/openreplay";
import Signup from "./Signup";
import InteractiveDemoPerformance from "./InteractiveDemo";
import CreateInterview from "components/CreateInterview";
import InterviewWizard from "./InterviewWizard";
import CodingAssessment from "components/CodingAssessment";
import CaseMasterAssessment from "components/CaseMasterAssessment";
import StartAssessmentForAPI from "./StartAssessmentForAPI";
import ShortlistingGenie from "components/ShortlistingGenie";
import ReviewComponent from "components/ShortlistingGenie/ReviewComponent";
import ShortlistFeedback from "components/ShortlistingGenie/ShortlistFeedback";
import ResumeGenerator from "components/ResumeGenerator";
import {InteractiveDemo4c, InteractiveDemoCaseMaster} from "./InteractiveDemo";
import { Session, FEATURE_IDS, isMobile } from "utils";
import MobileApp from "mobile";
  
export default function Screens() {
  useEffect(() => {
    initOpenReplay();
  }, []);

  console.log(Session);
  

  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <ErrorBoundary>
          <SingleSessionProvider>
            <LoadingProvider>
              <TourProvider>
                <SnackbarProvider>
                  <StackSnackbarProvider>
                    <ProctoringProvider>
                      <ConnectivityProvider>
                        <SessionHelper>
                          {isMobile() ? (
                            <MobileApp />
                          ) : (
                          <Routes>
                            <Route path=":client" >
                              <Route
                                index
                                element={<Navigate to='/guest/home' />}
                              />

                              <Route
                                path="home"
                                element={<PrivateRoute component={Home} />}
                              />

                              <Route
                                path="bookmark"
                                element={<PrivateRoute component={Bookmark} />}
                              />
                              <Route
                                path="profile"
                                element={<PrivateRoute component={Profile} />}
                              />
                              <Route
                                path="templates/*"
                                element={<PrivateRoute component={Performance} />}
                              />
                              <Route
                                path="performance/*"
                                element={<PrivateRoute component={Performance} />}
                              />
                              <Route
                                path="pathway/:id"
                                element={<PrivateRoute component={Pathway} />}
                              />
                              <Route
                                path="assessment"
                                element={<PrivateRoute component={Assessment} />}
                              />
                              <Route
                                path="coding-assessment"
                                element={<PrivateRoute component={CodingAssessment} />}
                              />
                              <Route
                                path="case-master-assessment"
                                element={<PrivateRoute component={CaseMasterAssessment} />}
                              />
                              <Route
                                path="onboarding"
                                element={<PrivateRoute component={Onboarding} />}
                              />
                              <Route
                                path="welcome"
                                element={<PrivateRoute component={Welcome} />}
                              />
                              <Route
                                path="register"
                                element={<Registration checkToken />}
                              />
                              <Route
                                path="blog/*"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.BLOG}
                                    element={<PrivateRoute component={Blog} />}
                                  />
                                }
                              />
                              <Route
                                path="personalized-interview"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.INTERVIEW_WIZARD}
                                    element={<PrivateRoute component={InterviewWizard} />}
                                  />
                                }
                              />
                              <Route
                                path="personalized-interview/:id"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.INTERVIEW_WIZARD}
                                    element={<PrivateRoute component={CreateInterview} />}
                                  />
                                }
                              />
                              <Route
                                path="shortlisting-genie"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.SHORTLISTING_GENIE}
                                    element={<PrivateRoute component={ShortlistingGenie} />}
                                  />
                                }
                              />
                              <Route
                                path="shortlisting-genie/only-resume"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.SHORTLISTING_GENIE}
                                    element={<PrivateRoute component={ReviewComponent} componentProps={{
                                      resumeOnly : true
                                    }}/>}
                                  />
                                }
                              />
                              <Route
                                path="shortlisting-genie/jd-plus-resume"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.SHORTLISTING_GENIE}
                                    element={<PrivateRoute component={ReviewComponent} componentProps={{
                                      resumeOnly : false
                                    }} />}
                                  />
                                }
                              />
                              <Route
                                path="shortlisting-genie/resume-generator"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.SHORTLISTING_GENIE}
                                    element={<PrivateRoute component={ResumeGenerator} />}
                                  />
                                }
                              />
                              <Route
                                path="performance/shortlist-genie/:id"
                                element={
                                  <FeatureRoute
                                    featureId={FEATURE_IDS.SHORTLISTING_GENIE}
                                    element={<PrivateRoute component={ShortlistFeedback} />}
                                  />
                                }
                              />

                              <Route path="login" element={<Login />} />
                              <Route path="signup" element={<Signup />} />
                              <Route path="auth" element={<Auth />} />
                              <Route path="auth/assessment-link" element={<AuthForAssessmentLink />} />
                              <Route path="activation" element={<Activation />} />
                            </Route>
                            <Route path="/batch/join" element={<BatchInvite />} />
                            <Route path="/signup" element={<Navigate to='/languify/signup' />} />
                            <Route path="/signin" element={<Navigate to='/languify/login' />} />
                            <Route path="verify-account" element={<VerifyAccount />} />
                            <Route path="privacy-policy" element={<PrivacyPolicy />} />
                            <Route path="forgot-password" element={<ForgotPassword />} />
                            <Route path="reset-password" element={<ResetPassword />} />
                            <Route
                              path="/performance/public"
                              element={<InteractiveDemoPerformance />}
                            />
                            <Route
                              path="/performance/4c/public"
                              element={<InteractiveDemo4c />}
                            />
                            <Route
                              path="/performance/case-master/public"
                              element={<InteractiveDemoCaseMaster />}
                            />
                            <Route path="/error" element={<Error />} />
                            <Route path="/error-admin" element={<DeactivatedProfile />} />
                            <Route path="/mobile-error" element={<MobileDeviceError />} />
                            <Route path="/unsupported-device" element={<UnsupportedDevice />} />
                            <Route path="/unsupported-browser" element={<UnsupportedBrowser />} />
                            <Route path="/workspace" element={<Workspace />} />
                            <Route path="/" element={<Navigate to='/guest/home' />} />
                            <Route path="*" element={<NotFound />} />
                          </Routes>
                          )}
                        </SessionHelper>
                      </ConnectivityProvider>
                    </ProctoringProvider>
                  </StackSnackbarProvider>
                </SnackbarProvider>
              </TourProvider>
            </LoadingProvider>
          </SingleSessionProvider>
        </ErrorBoundary>
      </ThemeProvider>
    </BrowserRouter>
  );
}
